export const ACTIVATE_TEMPLATE = 'ACTIVATE_TEMPLATE'
export const APPEND_ITEMS = 'APPEND_ITEMS'
export const AUTHENTICATE = 'AUTHENTICATE'
export const CHANGES_MADE = 'CHANGES_MADE'
export const CLEAR_CHANGES = 'CLEAR_CHANGES'
export const INVALID_VARIABLES = 'INVALID_VARIABLES'
export const CHANGE_VARIABLE_ORDER = 'CHANGE_VARIABLE_ORDER'
export const CHANGE_MODIFIER_ORDER = 'CHANGE_MODIFIER_ORDER'
export const CHANGE_INSTANCE_ORDER = 'CHANGE_INSTANCE_ORDER'
export const CLEAR_DELETED_VARIABLES = 'CLEAR_DELETED_VARIABLES'
export const CLEAR_ITEM = 'CLEAR_ITEM'
export const CLEAR_NEW_VARIABLE = 'CLEAR_NEW_VARIABLE'
export const CLEAR_SCHEMA = 'CLEAR_SCHEMA'
export const CREATE_VARIABLE = 'CREATE_VARIABLE'
export const CREATE_DATASOURCE = 'CREATE_DATASOURCE'
export const EDIT_DATASOURCE = 'EDIT DATASOURCE'
export const CLEAR_EDIT_DATASOURCE = 'CLEAR_EDIT_DATASOURCE'
export const UPDATE_DATA_SOURCE = 'UPDATE_DATA_SOURCE'
export const DELETE_DATA_SOURCE = 'DELETE_DATA_SOURCE'
export const UPDATE_DATA_SOURCE_NAME = 'UPDATE_DATA_SOURCE_NAME'
export const GENERATE_GETTER = 'GENERATE_GETTER'
export const GENERATE_OPERATOR = 'GENERATE_OPERATOR'
export const CLONE_VARIABLE = 'CLONE_VARIABLE'
export const DELETE_VARIABLE = 'DELETE_VARIABLE'
export const DELETED_VARIABLES_CLEARED = 'DELETED_VARIABLES_CLEARED'
export const DEACTIVATE_TEMPLATE = 'DEACTIVATE_TEMPLATE'
export const DEACTIVATE_TEMPLATES = 'DEACTIVATE_TEMPLATES'
export const EDIT_VARIABLE = 'EDIT_VARIABLE'
export const EDIT_VARIABLES = 'EDIT_VARIABLES'
export const EDIT_INSTANCE = 'EDIT_INSTANCE'
export const SHOW_SELECTOR = 'SHOW_SELECTOR'
export const HIDE_NAME_FIELD = 'HIDE_NAME_FIELD'
export const HIDE_SELECTOR = 'HIDE_SELECTOR'
export const INIT_NEW_VARIABLE = 'INIT_NEW_VARIABLE'
export const SET_MAX_TEMPLATES = 'SET_MAX_TEMPLATES'
export const SET_AUTH_STATUS = 'SET_AUTH_STATUS'
export const SET_STAND_ALONE_MODE = 'SET_STAND_ALONE_MODE'
export const SET_SHOW_CAVEON_ID_MODAL = 'SET_SHOW_CAVEON_ID_MODAL'
export const SET_PRIMARY_COLOR = 'SET_PRIMARY_COLOR'
export const SET_SECONDARY_COLOR = 'SET_SECONDARY_COLOR'
export const SET_PREVIEW_URL = 'SET_PREVIEW_URL'
export const STOP_EDITING = 'STOP_EDITING'
export const STOP_EDITING_VARIABLES = 'STOP_EDITING_VARIABLES'
export const STORE_BEARER_TOKEN = 'STORE_BEARER_TOKEN'
export const STORE_ITEM = 'STORE_ITEM'
export const STORE_ITEMS = 'STORE_ITEMS'
export const STORE_SCHEMA = 'STORE_SCHEMA'
export const STORE_TEMPLATES = 'STORE_TEMPLATES'
export const STORE_USER = 'STORE_USER'
export const UNAUTHENTICATE = 'UNAUTHENTICATE'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const UPDATE_OPTIONS_ORDER = 'UPDATE_OPTIONS_ORDER'
export const UPDATE_MATCH_ORDER = 'UPDATE_MATCH_ORDER'
export const UPDATE_ITEM_CODE = 'UPDATE_ITEM_CODE'
export const UPDATE_ITEM_NAME = 'UPDATE_ITEM_NAME'
export const UPDATE_VARIABLE = 'UPDATE_VARIABLE'
export const UPDATE_VARIABLE_MACRO = 'UPDATE_VARIABLE_MACRO'
export const UPDATE_VARIABLE_MODIFIER = 'UPDATE_VARIABLE_MODIFIER'
export const UPDATE_VARIABLE_INSTANCE = 'UPDATE_VARIABLE_INSTANCE'
export const UPDATE_VAR_NAME_MAP = 'UPDATE_VAR_NAME_MAP'



// WEBPACK FOOTER //
// /app/js/actions/types.js